import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        // localStorage'dan kaydedilmiş dili al, yoksa varsayılan 'fa'
        return localStorage.getItem('language') || 'fa';
    });

    useEffect(() => {
        // Dil değiştiğinde localStorage'a kaydet
        localStorage.setItem('language', language);
        // HTML lang attribute'unu güncelle
        document.documentElement.lang = language;
        // HTML dir attribute'unu güncelle
        document.documentElement.dir = language === 'fa' ? 'rtl' : 'ltr';
    }, [language]);

    const changeLanguage = (lang) => {
        setLanguage(lang.toLowerCase());
    };

    const value = {
        language,
        changeLanguage,
        isFA: language === 'fa',
        isEN: language === 'en'
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};